import { IgetHistoryAPIBody } from 'api/endpoints/dataIntegration/dataIntegration.response.interface';
import { IInitialDataIntegrationState } from 'interfaces/dataIntegration.interface';

export const initialUploadsHistoryBody: IgetHistoryAPIBody = {
  order: ['createdAt', 'DESC'],
  index: 0,
  limit: 10,
  brand_id: '',
};

const initialDataIntegrationState: IInitialDataIntegrationState = {
  // History
  importFilesHistoryBody: initialUploadsHistoryBody,
  importFilesHistory: {
    count: 0,
    total: 0,
    data: [],
  },
  getImportFilesHistory: () => Promise.resolve(false),
  isLoadingGetImportFilesHistory: false,
  handlePagination: () => Promise.resolve(false),
  selectedImportFilesHistory: null,
  selectImportFilesHistory: () => {},
  // Audiences
  audiences: [],
  getAudiences: () => Promise.resolve(false),
  isLoadingGetAudiences: false,
  audienceSelected: null,
  selectAudience: () => {},
  createAudience: () => Promise.resolve(false),
  isLoadingCreateAudience: false,
  updateAudience: () => Promise.resolve(false),
  isLoadingUpdateAudience: false,
  // Mapping fields
  mappingFields: [],
  getMappingFields: () => Promise.resolve(false),
  isLoadingGetMappingFields: false,
  mappingFieldsAudienceSelected: null,
  mappingFieldSelected: null,
  selectMappingField: () => {},
  createMappingField: () => Promise.resolve(false),
  isLoadingCreateMappingField: false,
  updateMappingField: () => Promise.resolve(false),
  isLoadingUpdateMappingField: false,
  deleteMappingField: () => Promise.resolve(false),
  isLoadingDeleteMappingField: {
    mappingFieldId: null,
    isLoading: false,
  },
  // Mappings
  mappings: [],
  getMappings: () => Promise.resolve(false),
  isLoadingGetMappings: false,
  mappingSelected: null,
  selectMapping: () => {},
  createMapping: () => Promise.resolve(false),
  isLoadingCreateMapping: false,
  createMappingSelected: null,
  selectCreateMapping: () => {},
  updateMapping: () => Promise.resolve(false),
  isLoadingUpdateMapping: false,
  deleteMap: () => Promise.resolve(false),
  isLoadingDeleteMap: {
    mapId: null,
    isLoading: false,
  },
  csvSelected: {
    papa: null,
    file: null,
  },
  setCSVSelected: () => Promise.resolve(false),
  isLoadingCSVSelected: false,
  setIsLoadingCSVSelected: () => {},
  recordToUpdate: null,
  setRecordToUpdate: () => {},
  // Points of sale dictionaries
  pointsOfSaleDictionary: [],
  getPointsOfSaleDictionary: () => Promise.resolve(false),
  isLoadingGetPointsOfSaleDictionary: false,
  pointOfSaleDictionarySelected: null,
  selectPointOfSaleDictionary: () => {},
  createPointsOfSaleDictionary: () => Promise.resolve(false),
  isLoadingCreatePointsOfSaleDictionary: false,
  updatePointsOfSaleDictionary: () => Promise.resolve(false),
  isLoadingUpdatePointsOfSaleDictionary: false,
  deletePointsOfSaleDictionary: () => Promise.resolve(false),
  isLoadingDeletePointOfSaleDictionary: {
    pointOfSaleDictionaryId: null,
    isLoading: false,
  },
  // Files Patterns
  filePatterns: [],
  getFilePatterns: () => Promise.resolve(false),
  isLoadingGetFilePatterns: false,
  createFilePattern: () => Promise.resolve(false),
  isLoadingCreateFilePattern: false,
  // Upload files
  uploadFiles: () =>
    Promise.resolve({
      ok: false,
      confirmedItems: [],
    }),
  isLoadingUploadFiles: false,
  setIsLoadingUploadFiles: () => {},
  // Reprocess imports
  reprocessImport: () => Promise.resolve(false),
  isLoadingReprocessImport: false,
  updateInboxFileEncoding: () => Promise.resolve(false),
  isLoadingUpdateInboxFileEncoding: false,
  archiveFileHistory: () => Promise.resolve(false),
  isLoadingArchiveFileHistory: {
    importHistoryIds: null,
    isLoading: false,
  },
};

export default initialDataIntegrationState;

export const xlsxDateFormat = 'DD/MM/YYYY';

export const dateFormats = [
  // XX-XX-XXXX
  'YYYY-MM-DD',
  'YY-MM-DD',
  'DD-MM-YYYY',
  'DD-MM-YY',
  'MM-DD-YYYY',
  'MM-DD-YY',
  'YYYY-MM-DD hh:mm:ss',
  'MM-DD-YYYY hh:mm:ss',
  'DD-MM-YYYY hh:mm:ss',
  'YY-MM-DD hh:mm:ss',
  'MM-DD-YY hh:mm:ss',
  'DD-MM-YY hh:mm:ss',
  'YYYY-MM-DD HH:mm:ss',
  'MM-DD-YYYY HH:mm:ss',
  'DD-MM-YYYY HH:mm:ss',
  'YY-MM-DD HH:mm:ss',
  'MM-DD-YY HH:mm:ss',
  'DD-MM-YY HH:mm:ss',
  'YYYY-MM-DD H:mm:ss',
  'DD-MM-YYYY H:mm:ss',
  'MM-DD-YYYY H:mm:ss',
  'YY-MM-DD H:mm:ss',
  'DD-MM-YY H:mm:ss',
  'MM-DD-YY H:mm:ss',
  'YYYY-MM-DD hh:mm',
  'MM-DD-YYYY hh:mm',
  'DD-MM-YYYY hh:mm',
  'YY-MM-DD hh:mm',
  'MM-DD-YY hh:mm',
  'DD-MM-YY hh:mm',
  'YYYY-MM-DD HH:mm',
  'MM-DD-YYYY HH:mm',
  'DD-MM-YYYY HH:mm',
  'YY-MM-DD HH:mm',
  'MM-DD-YY HH:mm',
  'DD-MM-YY HH:mm',
  'YYYY-MM-DD H:mm',
  'MM-DD-YYYY H:mm',
  'DD-MM-YYYY H:mm',
  'YY-MM-DD H:mm',
  'MM-DD-YY H:mm',
  'DD-MM-YY H:mm',
  // XX/XX/XXXX
  'YYYY/MM/DD',
  'YY/MM/DD',
  'DD/MM/YYYY',
  'DD/MM/YY',
  'MM/DD/YYYY',
  'MM/DD/YY',
  'YYYY/MM/DD hh:mm:ss',
  'DD/MM/YYYY hh:mm:ss',
  'MM/DD/YYYY hh:mm:ss',
  'YY/MM/DD hh:mm:ss',
  'DD/MM/YY hh:mm:ss',
  'MM/DD/YY hh:mm:ss',
  'YYYY/MM/DD HH:mm:ss',
  'DD/MM/YYYY HH:mm:ss',
  'MM/DD/YYYY HH:mm:ss',
  'YY/MM/DD HH:mm:ss',
  'DD/MM/YY HH:mm:ss',
  'MM/DD/YY HH:mm:ss',
  'YYYY/MM/DD H:mm:ss',
  'DD/MM/YYYY H:mm:ss',
  'MM/DD/YYYY H:mm:ss',
  'YY/MM/DD H:mm:ss',
  'DD/MM/YY H:mm:ss',
  'MM/DD/YY H:mm:ss',
  'YYYY/MM/DD hh:mm',
  'DD/MM/YYYY hh:mm',
  'MM/DD/YYYY hh:mm',
  'YY/MM/DD hh:mm',
  'DD/MM/YY hh:mm',
  'MM/DD/YY hh:mm',
  'YYYY/MM/DD HH:mm',
  'DD/MM/YYYY HH:mm',
  'MM/DD/YYYY HH:mm',
  'YY/MM/DD HH:mm',
  'DD/MM/YY HH:mm',
  'MM/DD/YY HH:mm',
  'YYYY/MM/DD H:mm',
  'DD/MM/YYYY H:mm',
  'MM/DD/YYYY H:mm',
  'YY/MM/DD H:mm',
  'DD/MM/YY H:mm',
  'MM/DD/YY H:mm',
  // XX.XX.XXXX
  'YYYY.MM.DD',
  'YY.MM.DD',
  'DD.MM.YYYY',
  'DD.MM.YY',
  'MM.DD.YYYY',
  'MM.DD.YY',
  'YYYY.MM.DD hh:mm:ss',
  'DD.MM.YYYY hh:mm:ss',
  'MM.DD.YYYY hh:mm:ss',
  'YY.MM.DD hh:mm:ss',
  'DD.MM.YY hh:mm:ss',
  'MM.DD.YY hh:mm:ss',
  'YYYY.MM.DD HH:mm:ss',
  'DD.MM.YYYY HH:mm:ss',
  'MM.DD.YYYY HH:mm:ss',
  'YY.MM.DD HH:mm:ss',
  'DD.MM.YY HH:mm:ss',
  'MM.DD.YY HH:mm:ss',
  'YYYY.MM.DD H:mm:ss',
  'DD.MM.YYYY H:mm:ss',
  'MM.DD.YYYY H:mm:ss',
  'YY.MM.DD H:mm:ss',
  'DD.MM.YY H:mm:ss',
  'MM.DD.YY H:mm:ss',
  'YYYY.MM.DD hh:mm',
  'MM.DD.YYYY hh:mm',
  'DD.MM.YYYY hh:mm',
  'YY.MM.DD hh:mm',
  'MM.DD.YY hh:mm',
  'DD.MM.YY hh:mm',
  'YYYY.MM.DD HH:mm',
  'MM.DD.YYYY HH:mm',
  'DD.MM.YYYY HH:mm',
  'YY.MM.DD HH:mm',
  'MM.DD.YY HH:mm',
  'DD.MM.YY HH:mm',
  'YYYY.MM.DD H:mm',
  'MM.DD.YYYY H:mm',
  'DD.MM.YYYY H:mm',
  'YY.MM.DD H:mm',
  'MM.DD.YY H:mm',
  'DD.MM.YY H:mm',
  // XXXXXXXX
  'YYYYMMDD',
  'DDMMYYYY',
  'MMDDYYYY',
  'YYMMDD',
  'DDMMYY',
  'MMDDYY',
  'YYYYMMDD hh:mm:ss',
  'DDMMYYYY hh:mm:ss',
  'MMDDYYYY hh:mm:ss',
  'YYMMDD hh:mm:ss',
  'DDMMYY hh:mm:ss',
  'MMDDYY hh:mm:ss',
  'YYYYMMDD HH:mm:ss',
  'DDMMYYYY HH:mm:ss',
  'MMDDYYYY HH:mm:ss',
  'YYMMDD HH:mm:ss',
  'DDMMYY HH:mm:ss',
  'MMDDYY HH:mm:ss',
  'YYYYMMDD H:mm:ss',
  'DDMMYYYY H:mm:ss',
  'MMDDYYYY H:mm:ss',
  'YYMMDD H:mm:ss',
  'DDMMYY H:mm:ss',
  'MMDDYY H:mm:ss',
  'YYYYMMDD hh:mm',
  'MMDDYYYY hh:mm',
  'DDMMYYYY hh:mm',
  'YYMMDD hh:mm',
  'MMDDYY hh:mm',
  'DDMMYY hh:mm',
  'YYYYMMDD HH:mm',
  'MMDDYYYY HH:mm',
  'DDMMYYYY HH:mm',
  'YYMMDD HH:mm',
  'MMDDYY HH:mm',
  'DDMMYY HH:mm',
  'YYYYMMDD H:mm',
  'MMDDYYYY H:mm',
  'DDMMYYYY H:mm',
  'YYMMDD H:mm',
  'MMDDYY H:mm',
  'DDMMYY H:mm',
  //////////////////////////////
  'YYYY-MM-DDTHH:mm:ss',
  'YYYY-MM-DDTHH:mm:ssZ',
  'YYYY-MM-DDTHH:mm:ss.SSSZ',
  //////////////////////////////
  'DD-MMM-YY',
];

export const tiemFormats = [
  'hh:mm:ss',
  'HH:mm:ss',
  'hh:mm',
  'HH:mm',
  'hhmmss',
  'HHmmss',
  'h:mm:ss',
  'H:mm:ss',
  'h:mm',
  'H:mm',
  'hmmss',
  'Hmmss',
];

export const encodingFormats = [
  { value: 'ascii', label: 'ASCII' },
  { value: 'iso-8859-1', label: 'ISO-8859-1' },
  { value: 'iso-8859-2', label: 'ISO-8859-2' },
  { value: 'iso-8859-4', label: 'ISO-8859-4' },
  { value: 'iso-8859-6', label: 'ISO-8859-6' },
  { value: 'iso-8859-7', label: 'ISO-8859-7' },
  { value: 'iso-8859-8', label: 'ISO-8859-8' },
  { value: 'iso-8859-9', label: 'ISO-8859-9' },
  { value: 'iso-8859-13', label: 'ISO-8859-13' },
  { value: 'iso-8859-15', label: 'ISO-8859-15' },
  { value: 'koi8-r', label: 'KOI8-R' },
  { value: 'koi8-u', label: 'KOI8-U' },
  { value: 'tis-620', label: 'TIS-620' },
  { value: 'utf-8', label: 'UTF-8' },
  { value: 'utf-16le', label: 'UTF-16 LE' },
  { value: 'utf-16be', label: 'UTF-16 BE' },
  { value: 'utf-32le', label: 'UTF-32 LE' },
  { value: 'utf-32be', label: 'UTF-32 BE' },
  { value: 'windows-874', label: 'Windows-874' },
  { value: 'windows-1250', label: 'Windows-1250' },
  { value: 'windows-1251', label: 'Windows-1251' },
  { value: 'windows-1252', label: 'Windows-1252' },
  { value: 'windows-1253', label: 'Windows-1253' },
  { value: 'windows-1254', label: 'Windows-1254' },
  { value: 'windows-1255', label: 'Windows-1255' },
  { value: 'windows-1256', label: 'Windows-1256' },
  { value: 'windows-1257', label: 'Windows-1257' },
  { value: 'windows-1258', label: 'Windows-1258' },
];
